module.exports = dormakaba.vendorTerrific['@dormakaba/notifications'];